import { createRouter, createWebHistory } from 'vue-router';
import Home from '../pages/index.vue';
import MyPage from '../pages/myPage.vue';

// community
import Community from '../pages/community.vue';
import CommunityView from '../pages/community_view.vue';
import CommunityWrite from '../pages/community_write.vue';
import CommunityWrite2 from '../pages/community_write2.vue'
import EventLeague from '../pages/eventLeague.vue'
import EventLeagueView from '../pages/eventLeague_view.vue'

// customer center
import Notice from '../pages/notice.vue';
import NoticeView from '../pages/notice_view.vue';
import Policy from '../pages/policy.vue';
import Privacy from '../pages/privacy.vue';
import Qna from '../pages/qna.vue';
import QnaWrite from '../pages/qna_write.vue';

import LoginFirst from '../pages/login_first.vue';

import Ranking from '../pages/trade/ranking.vue';
import ItemListCoin from '../pages/trade/itemList_coin.vue';
import ItemListStock from '../pages/trade/itemList_stock.vue';
import ItemListFutures from '../pages/trade/itemList_futures.vue';
import ItemListCoinFutures from '../pages/trade/itemList_coinFutures.vue';


import OrderBook from '../pages/trade/orderBook.vue';
import TradeResult from '../pages/trade/tradeResult.vue';
import TradeResultCF from '../pages/trade/tradeResult_cf.vue';
import TradeChart from '../pages/trade/tradeChart.vue';
import TradeArea from '../pages/trade/tradeArea.vue';
import LiveBroadcast from '../pages/trade/liveBroadcast.vue';
import TradeReward from '../pages/trade/trade_reward.vue';
import TradeResultAll from '../pages/trade/tradeResult_all.vue';

// App 약관/정책
import AppPolicy from '../pages/app/policy.vue';
import AppPrivacy from '../pages/app/privacy.vue';
import AppCommunityPolicy from '../pages/app/communityPolicy.vue';
import NotFound from '../pages/notFound.vue';

const router = createRouter({
    history: createWebHistory(),
    scrollBehavior(){
        return { top: 0 }
    },
    routes: [  
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/myPage',
            name: 'MyPage',
            component: MyPage
        },
        {
            path: '/community',
            name: 'Community',
            component: Community
        },
        {
            path: '/community/:id',           
            name: 'CommunityView',
            component: CommunityView
        },
        {
            path: '/communityWrite/:id?',           
            name: 'CommunityWrite',
            component: CommunityWrite
        },
        {
            path: '/communityWrite2',           
            name: 'CommunityWrite2',
            component: CommunityWrite2
        },
        {
            path: '/ranking',
            name: 'Ranking',
            component: Ranking,
        },
        {
            path: '/loginFirst',
            name: 'LoginFirst',
            component: LoginFirst
        },
        // 고객센터
        {
            path: '/notice',
            name: 'Notice',
            component: Notice
        },
        {
            path: '/notice/:id',
            name: 'NoticeView',
            component: NoticeView
        },
        {
            path: '/policy',
            name: 'Policy',
            component: Policy
        },
        {
            path: '/privacy',
            name: 'Privacy',
            component: Privacy
        },
        {
            path: '/qna',
            name: 'Qna',
            component: Qna
        },    
        {
            path: '/qnaWrite/:id?',
            name: 'QnaWrite',
            component: QnaWrite
        }, 
        {
            path: '/TradeArea/:id&:code',
            name: 'TradeArea',
            component: TradeArea
        },
        {
            path: '/orderBook/:id&:code?',
            name: 'OrderBook',
            component: OrderBook,
           
        },
        {
            path: '/tradeResult/:id&:code?',
            name: 'TradeResult',
            component: TradeResult,
           
        },
        {
            path: '/tradeResultCF/:id&:code?',
            name: 'TradeResultCF',
            component: TradeResultCF,
           
        },
        {
            path: '/tradeChart/:id&:code?',
            name: 'TradeChart',
            component: TradeChart,
           
        },
        {
            path: '/itemListStock/:id',
            name: 'ItemListStock',
            component: ItemListStock
        },
        {
            path: '/itemListFutures/:id',
            name: 'ItemListFutures',
            component: ItemListFutures
        },
        {
            path: '/itemListCoin/:id',
            name: 'ItemListCoin',
            component: ItemListCoin
        },
        {
            path: '/itemListCoinFutures/:id',
            name: 'ItemListCoinFutures',
            component: ItemListCoinFutures
        },
        {
            path: '/liveBroadcast/:id',
            name: 'LiveBroadcast',
            component: LiveBroadcast
        },
        {
            path: '/app/policy',
            name: 'AppPolicy',
            component: AppPolicy
        },
        {
            path: '/app/privacy',
            name: '/appAppPrivacy',
            component: AppPrivacy
        },     
        {
            path: '/app/communityPolicy',
            name: 'AppCommunityPolicy',
            component: AppCommunityPolicy
        },
        // 상금수령 페이지 추가
        {
            path: '/tradeReward',
            name: 'TradeReward',
            component: TradeReward,  
        },
        //이벤트리그 관련 추가 페이지  
        {
            path: '/eventLeague/:type',
            name: 'EventLeague',
            component: EventLeague
        },    
        {
            path: '/eventLeagueView/:id',
            name: 'EventLeagueView',
            component: EventLeagueView
        },                
        {
            path: '/tradeResultAll',
            name: 'TradeResultAll',
            component: TradeResultAll
        },
        {
            path: '/:pathMatch(.*)*',
            name: 'NotFound',
            component: NotFound
        },

    ]
});

router.afterEach((to, from) => {
  // callDM 초기화 코드가 이미 <head>에 삽입되어 있다고 가정
    if (typeof window.callDM === 'function') {    
            window.callDM('page_view', {
                path: to.fullPath,
                name: to.name,
                from: from.fullPath
            })
    }
})


export default router;
